import gsap, { ScrollTrigger, SplitText, CustomEase } from "gsap/all";
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(SplitText);
gsap.registerPlugin(CustomEase);
function initScrollAnimation() {
    const elementSelectors = [
        ".content > h1",
        ".content > h2",
        ".content > h3",
        ".content > h4",
        ".content > p",
        ".content > a",
        ".content > .wp-block-image",
        ".footer, .content > .wp-block-buttons",
        ".archive-dienst",
        ".featured-case",
        ".reviews",
        ".team-member",
        ".contact-item",
        "blockquote",
        ".impression-case",
        ".blog-post",
    ];
    const staggerElementSelectors = [
        [".diensten", ".dienst"],
        [".werkwijze-slider", ".werkwijze-slider-item"],
        [".case-slider", ".case-slider-item"],
        [".content ul", ".content li"],
        [".wp-block-columns", ".wp-block-column"],
    ];
    const elements = document.querySelectorAll(elementSelectors.join(","));
    elements.forEach((element, index) => {
        if (!element)
            return;
        gsap.from(element, {
            y: 50,
            autoAlpha: 0,
            duration: 2,
            ease: CustomEase.create("custom", "M0,0 C0.505,0 0.096,1 1,1 "),
            scrollTrigger: {
                trigger: element,
                start: "top 85%",
            },
        });
    });
    staggerElementSelectors.forEach((entry) => {
        const [container, selector] = entry;
        if (!document.querySelector(selector))
            return;
        gsap.from(selector, {
            y: 50,
            autoAlpha: 0,
            stagger: 0.25,
            duration: 2,
            ease: CustomEase.create("custom", "M0,0 C0.505,0 0.096,1 1,1 "),
            scrollTrigger: {
                trigger: container,
                start: "top 95%",
            },
        });
    });
    window.addBeforeNavigate(() => {
        gsap.globalTimeline.getChildren().forEach((c) => c.kill());
    }, "kill-all-gsap", false);
}
export default initScrollAnimation;
